import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { Typography, MenuItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { QuickLinks as quickLinks } from '../../constants/quickLinks';
import { WS_ACTION_TYPES } from '../../redux-saga/actionTypes';
import styles from './styles';

const QuickLinks = ({ t, classes, sendMessageToSocket }) => {
  const onHandleClick = message => {
    sendMessageToSocket(message);
  };

  return (
    <React.Fragment>
      <div className={classes.scroll__wheel}>
        {quickLinks.map(list => (
          <MenuItem className={classes.menu__container} onClick={() => onHandleClick(list.message)}>
            <ListItemIcon>
              <img src={list.icon} alt={list.name} className={classes.icons} />
            </ListItemIcon>
            <ListItemText>
              <Typography className={classes.title}>
                {t(`destinations.label.${list.name}`)}
              </Typography>
            </ListItemText>
          </MenuItem>
        ))}
      </div>
      <div className={classes.overlay} />
    </React.Fragment>
  );
};

QuickLinks.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  sendMessageToSocket: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  sendMessageToSocket: payload => dispatch({ type: WS_ACTION_TYPES.WS.ON_COMMANDS, payload }),
});

export default withTranslation()(
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps,
    )(QuickLinks),
  ),
);
